module.exports = __webpack_public_path__ + "img/other_pay_wechatpay2.b3eb3d5c.svg";